<section id="cloudDetails" class="rs-content-wrapper rs-header-has-level2">
  <main id="maincontent" role="main">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1 class="rs-tit1-sp rs-txt-c2">
            {{ 'cloud.details.title' | translate }}
          </h1>
          <div class="rs-panel-big rs-bg-c2 clearfix">
            <p [innerHTML]="'cloud.details.description' | translate: true"></p>
            <div class="rs-flex-row">
              <div class="rs-flex-columns small-12 medium-4">
                <mprd-cloud-subscription></mprd-cloud-subscription>
              </div>
              <div class="rs-flex-columns small-12 medium-4">
                <mprd-cloud-access></mprd-cloud-access>
              </div>
              <div class="rs-flex-columns small-12 medium-4">
                <mprd-cloud-download></mprd-cloud-download>
              </div>
            </div>

            <div class="rs-me"></div>

            <h2>{{ 'cloud.details.faqTitle' | translate }}</h2>

            <p [innerHTML]="'cloud.details.faqContent' | translate: true"></p>
          </div>
          <div class="rs-le2"></div>
        </div>
      </div>
    </section>
  </main>
</section>
